<template>
  <div>
    <div>
      <div class="bgBanner" >
      </div>
    </div>
    <div class="pos-rel" ref="section">
      <navTitle title="信息服务" class="op0 feature-title" :class="getAnimationClass('section', 'animate__fadeInUp')" ></navTitle>
      <div class="feature" @click="$goPath('/infoManage/cargoSourceMyInfo', true)">
        <img width="100%" height="100%" ref="section1" :class="getAnimationClass('section1', 'animate__fadeInUp')" :src="helperData[0] && setImgPath(helperData[0].coverImageUrl)" alt="">
        <div class="but2"  ref="section2" :class="getAnimationClass('section2', 'animate__fadeInUp')">免费体验</div>
      </div>
    </div>

  </div>
</template>
<script>
import navTitle from '@/components/navTitle/index.vue'
import { observers } from '@/mixins/observers'
import {getInfo} from '@/api/news'
import {imgRules, setImgPath} from '@/utils/index'
export default {
  name: 'index',
  components: { navTitle },
  mixins: [observers],
  data() {
    return {
      visibleMap: {},  // 动态记录每个模块是否可见
      observer: null,
      refNames: ['section', 'section1', 'section2', 'section3', 'section4', 'section5', 'section6', 'section7'],
      caseData: [],
      helperData: [],
    }
  },
  methods: {
    async getInfos () {
      const { data } = await getInfo({
        categoryCode: 'CASE_SERVICE',
        keyword: '车货匹配流程',
        limit: 4
      })
      this.caseData = data
    },
    imgRules,
    setImgPath,
    async getHelper () {
      const { data } = await getInfo({
        categoryCode: 'HELP',
        keyword: '车货匹配流程',
        limit: 4
      })
      this.helperData = data
    }
  },
  mounted() {
    this.getHelper()
  }
}
</script>


<style scoped lang="less">
.but2{
  position: absolute;
  top: 20px;
  right: 20px;
}

.bgBanner{
  background: url('../../assets/images/project/xxfw.jpg') center no-repeat;
  background-size: 100% 560px;
  width: 100%;
  height: 560px;
  position: relative;
}
.pos-rel {
  position: relative;
}
.feature-title {
  position: absolute;
  top: 42px;
  left: 41%;
  transform: translateX(-50%);
}
.feature{
  width: 100%;
  overflow: hidden;
  cursor: pointer;

  img{
    object-fit: cover;
  }
  .items1{
    background: url('../../assets/images/project/featureImg1.png') center no-repeat;
    background-size: cover;
    width: 784px;
    height: 227px;
    padding: 43px 510px 0 51px;
  }
  .items1Bg{
    background-image: url("../../assets/images/project/featureImg2.png");
  }

  .items2{
    background: url('../../assets/images/project/featureImg3.png') center no-repeat;
    background-size: cover;
    width: 400px;
    height: 470px;
    padding: 43px 120px 0 51px;
  }
  .item3{
    background: url('../../assets/images/project/featureImg4.png') center no-repeat;
    background-size: cover;
    width: 590px;
    height: 220px;
    padding: 43px 310px 0 51px;
  }
  .item3BgImg{
    background-image: url("../../assets/images/project/featureImg5.png");
  }
}
.feature2{
  background: linear-gradient( 135deg, #1B4DC1 0%, #0F3EAA 100%);
  height: 100vh;
  width: 100%;
  min-height: 680px;
  padding-top: 22px;
  padding-left: 10px;
  .pt52{
    padding-top: 52px;
  }
  .w260{
    width: 260px;
  }
}
.featureImg7{
  position: absolute;
  bottom: 0;
  right: 0;
  width: 500px;
  height: 576px;
}
.hb100{
  height: 100%;
  overflow: hidden;
}
.imgTitle{
  position: absolute;
  bottom: 0;
  line-height: 50px;
  left: 0;
  width: 100%;
  text-align: center;
}
</style>